import { CopyIcon } from '@chakra-ui/icons';
import { Box, Flex, Grid, Image, Link, Text, Tooltip } from '@chakra-ui/react';
import { FC, useEffect, useState } from 'react';
import { config, IconAssets } from 'src/config';
import { useBlockchainProvider } from 'src/providers/Blockchain/blockchainProvider';
import { CopyAddressConfirmedIcon } from 'src/utils/icons/copyAddressConfirmed';
import { licenseColorToHex, trimAddress } from 'src/utils/utils';
import { GameIcon } from './GameIcon/gameIcon';
import { GameMiniHeader } from './GameMiniHeader/gameMiniHeader';

interface Props {
	title: string;
	abbreviation: string;
	logoUrl: string;
	color: string;
	address: string;
}

export const GameMini: FC<Props> = ({ title, abbreviation, logoUrl, address, color }) => {
	const [copiedAnimation, setCopiedAnimation] = useState<boolean>(false);

	useEffect(() => {
		if (copiedAnimation == true) {
			setTimeout(() => {
				setCopiedAnimation(false);
			}, 1000);
		}
	}, [copiedAnimation]);

	const handleCopyAddress = () => {
		navigator.clipboard.writeText(address);
		if (copiedAnimation == false) setCopiedAnimation(true);
	};

	return (
		<Grid
			h="58px"
			templateColumns="58px auto"
			gridGap="22px"
		>
			<GameIcon url={logoUrl} />
			<Flex
				flexDir="column"
				justify="center"
			>
				<GameMiniHeader
					symbol={abbreviation}
					colorHex={licenseColorToHex(color)}
					title={title}
				/>
				<Flex
					align="center"
					gap="9px"
				>
					<Tooltip label="Copy to clipboard">
						<Flex
							color="#797B7E"
							fontSize="12px"
							align="center"
							gap="5px"
							cursor="pointer"
							onClick={handleCopyAddress}
						>
							{trimAddress(address, 6, 35)}
							{!copiedAnimation ? (
								<CopyIcon />
							) : (
								<Box
									filter="grayscale(1)"
									transform="translateY(-1px)"
								>
									<CopyAddressConfirmedIcon width={'12px'} />
								</Box>
							)}
						</Flex>
					</Tooltip>
					<Tooltip label="Visit on GameXplorer.io">
						<Link
							href={`${config.hashup.gamexplorerUrl}/game/${address}`}
							target="_blank"
						>
							<Image
								boxSize="13px"
								cursor="pointer"
								opacity="0.5"
								src={IconAssets.globe}
							/>
						</Link>
					</Tooltip>
				</Flex>
			</Flex>
		</Grid>
	);
};
